export default {
  namespaced: true,
  state: {
    preview: {
      active: false,
      file: {},
      url: '',
    },
  },
  getters: {
    getPreview: (state) => state.preview,
    getType: (state) => { return state.preview.file.type ? state.preview.file.type.match('pdf') : null },
  },
  mutations: {
    ADD_PREVIEW (state, status) {
      state.preview = status
    },
    CLEAR_PREVIEW (state) {
      state.preview = {
        active: false,
        file: {},
        url: ''
      }
    },
    OPEN_PREVIEW (state) {
      state.preview.active = true
    }
  },
  actions: {
    clearPreview ({ commit }) {
      commit('CLEAR_PREVIEW')
    },
    openPreview ({ commit }) {
      commit('OPEN_PREVIEW')
    },
    addPreview ({ commit }, status) {
      commit('ADD_PREVIEW', status)
    }
  }
}
